import { HttpStoriesResource } from './stories.js';
import { HttpVideosResource } from './videos.js';
export class HttpLibraryResource {
    stories;
    videos;
    constructor(httpClient) {
        this.stories = new HttpStoriesResource(httpClient);
        this.videos = new HttpVideosResource(httpClient);
    }
}
